// appConfig.ts

// Define a function to get config based on environment
function getConfig(env: string | undefined) {
  switch (env) {
    case 'development':
      return {
        env: 'development',
        apiBaseUrl: 'https://cloud.dkluter.com/api',  // fixed port to 3003 //http://localhost:3000/api
        basicAuth: {
          username: 'admin',
          password: 'admin@123',
        },
      };
    case 'production':
      return {
        env: 'production',
        apiBaseUrl: 'https://cloud.dkluter.com/api',
        basicAuth: {
          username: 'admin',
          password: 'admin@123',
        },
      };
      case 'beta':
        return {
          env: 'beta',
          apiBaseUrl: 'https://cloud.dkluter.com/api',  // fixed port to 3003 //http://localhost:3000/api
          basicAuth: {
            username: 'admin',
            password: 'admin@123',
          },
        };
    default:
      console.warn(`Unknown environment: ${env}. Falling back to development config.`);
      return {
        env: 'development',
        apiBaseUrl: 'https://cloud.dkluter.com/api',
        basicAuth: {
          username: 'admin',
          password: 'admin@123',
        },
      };
  }
}

// Get current config
const config = getConfig(process.env.REACT_APP_ENV);

export const AppConfig = config;

export const isDev = AppConfig.env === 'development';
